import { selectorFamily, useSetRecoilState } from "recoil";

import ClientAPI from "../api/clients.api";
import { clientsAtom, crudClientAtom } from "../atoms/clients.atoms";

const useClientsActions = () => {
  const setClients = useSetRecoilState(clientsAtom);
  const setCrudClient = useSetRecoilState(crudClientAtom);

  const clientsList = async ({ page = 1, limit = 10, search = null }, cb) => {
    setClients((prevValues) => ({ ...prevValues, loading: true }));
    try {
      let params = null;
      params = {
        paginationParams: { page, limit }
      };
      if (search) params.paginationParams.search = [search];

      const { data } = await ClientAPI.clientsList(params);
      if (cb) {
        cb(data);
      }
      setClients((prevValues) => ({ ...prevValues, loading: false, payload: data?.data || [], total: data?.total || 0 }));
    } catch (error) {
      setClients((prevValues) => ({ ...prevValues, loading: false, error }));
    }
  };

  const createClient = async (data, cb) => {
    setCrudClient((prevValues) => ({ ...prevValues, loading: true })); // TODO what for is this line ?
    try {
      const response = await ClientAPI.createClient(data);

      setCrudClient((prevValues) => ({
        ...prevValues,
        loading: false,
        status: response.status,
      }));

      if (cb) {
        cb(response.status);
      }
    } catch (error) {
      setCrudClient((prevValues) => ({
        ...prevValues,
        loading: false,
        message: error.message,
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  };

  const editClient = async (data, cb) => {
    setCrudClient((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const { planExternal, planInternal, email, phone, ...newObject } = data;
      
      const response = await ClientAPI.editClient(newObject.id, newObject)
      setCrudClient((prevValues) => ({
        ...prevValues,
        loading: false,
        status: response.status,
      }));

      if (cb) {
        cb(response.status);
      }

    } catch (error) {
      setCrudClient((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al editar cliente",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  }

  const resetClientCrud = () => setCrudClient({ status: 500, message: "", loading: false });

  return {
    clientsList,
    createClient,
    resetClientCrud,
    editClient
  };
}

const allClientsSelector = selectorFamily({
  key: "allClients",
  get: ({ page, limit }) => async () => {
    let params = null;
    params = {
      paginationParams: { page, limit }
    };
    const response = await ClientAPI.clientsList(params);
    if (response.error) {
      throw response.error;
    }
    return response?.data || [];
  },
});

export { allClientsSelector, useClientsActions };